// @flow strict

import type { DetailedProfileInfo } from './types';
import {
  validationSchema,
  validationSchemaWithUpflowy,
  passwordOnlyValidationSchema,
} from './validationSchema';

export const fieldDataFromSsoProvider = (profile: any, fieldName: string): boolean =>
  profile.isSso && ['firstName', 'lastName', 'password'].includes(fieldName);

const isJobTitleFullFilled = (profile: DetailedProfileInfo): boolean => {
  if (!profile) {
    return false;
  }

  if (profile.jobTitleId === 0) {
    return !!profile.jobTitleOther && !!profile.jobTitleGroupOther;
  }

  return profile.jobTitleId !== null && profile.jobTitleId !== undefined;
};

const rawValuePresents = (profile: any, fieldName: string) => {
  if (fieldName === 'jobTitleId') {
    return isJobTitleFullFilled(profile);
  }

  if (!profile) {
    return false;
  }

  return (
    profile &&
    profile[fieldName] !== null &&
    profile[fieldName] !== undefined &&
    profile[fieldName] !== ''
  );
};

const passwordExistsInIdentity = profile => !profile.isSso && profile.signUpCompleted;

// Consider a field value as "exists" if:
// - it's from SSO profile, and fields are mapped in Auth0
// - or it presents in a JSON field in profile
// - or it's password field of a non-SSO profile, and signUpCompleted === true (meaning Identity already stored password)
export const fieldValueExists = (profile: any, fieldName: string): any | boolean =>
  fieldDataFromSsoProvider(profile, fieldName) ||
  rawValuePresents(profile, fieldName) ||
  (fieldName === 'password' && passwordExistsInIdentity(profile));

export const isNullOrUndefined = (value: any): boolean => {
  return value == null || value === undefined;
};

export const getValidateSchema = (isProfileExists: boolean, enabledUpflowy: boolean) => {
  if (isProfileExists) {
    return passwordOnlyValidationSchema;
  }

  if (enabledUpflowy) {
    return validationSchemaWithUpflowy;
  }

  return validationSchema;
};
